import { useCallback, useEffect, useRef, useState } from 'react';

// The acknowledge tick on both forms' submit gates only activates once the
// summary has been read to the bottom. Also returns true when the summary is
// short enough not to scroll.
// `contentKey` names what the pane is showing: when it changes, the summary
// is a different length, so the end is looked for again rather than an end
// reached on a shorter one being kept.
export const useScrolledToEnd = (active, contentKey) => {
  const ref = useRef(null);
  const [reachedEnd, setReachedEnd] = useState(false);

  const check = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    if (el.scrollHeight - el.scrollTop - el.clientHeight <= 8) setReachedEnd(true);
  }, []);

  useEffect(() => {
    setReachedEnd(false);
    if (!active) return undefined;
    const id = requestAnimationFrame(check);
    return () => cancelAnimationFrame(id);
  }, [active, check, contentKey]);

  return { ref, reachedEnd, onScroll: check };
};
